import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, startWith, throttleTime } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '../../types';
import { apiObservable } from '@support/api';
import { SharedContact } from '@models/SharedContact';

/* Epic actions */
const sharedContactActions = requestActions('SHARED_CONTACT', ['fetch']);

/* Component actions */
export const fetchSharedContact = (contactUUID: ID, user: UserSession | null) =>
  sharedContactActions['fetch']({ contactUUID, authenticatedUser: !!user });

export const setSelectedSharedContact = (contact: SharedContact) => ({
  type: 'SET_SELECTED_SHARED_CONTACT',
  payload: { contact },
});

const fetchSharedContactEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_SHARED_CONTACT'),
    groupBy(({ payload }) => payload.contactUUID),
    mergeMap((fetchesByUUID) =>
      fetchesByUUID.pipe(
        throttleTime(1000 * 60 * 1),
        mergeMap(({ payload }) =>
          apiObservable('GET', `/network/shared-contacts/${payload.contactUUID}/`, undefined, {
            noAuthorization: !payload.authenticatedUser,
          }).pipe(
            map(({ response }) =>
              sharedContactActions['fetchSucceeded']({
                ...response,
                contactUUID: payload.contactUUID,
              }),
            ),
            startWith(sharedContactActions['fetchRequested']({ contactUUID: payload.contactUUID })),
            catchError((error) =>
              of(
                sharedContactActions['fetchFailed']({
                  error,
                  contactUUID: payload.contactUUID,
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const sharedContactsEpic = combineEpics(fetchSharedContactEpic);
